// blakfy-cookie/src/i18n/translations/es.js — Spanish translations

export default {
  title: "Preferencias de Cookies",
  intro:
    "Este sitio usa cookies para mejorar tu experiencia. Consulta nuestra Política de Cookies.",
  policyLink: "Política de Cookies",
  acceptAll: "Aceptar todo",
  rejectAll: "Rechazar todo",
  preferences: "Preferencias",
  save: "Guardar opciones",
  close: "Cerrar",
  cat: {
    essential: {
      title: "Cookies esenciales",
      desc: "Necesarias para el funcionamiento del sitio. No se pueden desactivar.",
      always: "Siempre activo",
    },
    analytics: {
      title: "Cookies analíticas",
      desc: "Usadas para recopilar estadísticas de visita anónimas.",
    },
    marketing: {
      title: "Cookies de marketing",
      desc: "Usadas para publicidad personalizada y retargeting.",
    },
    functional: {
      title: "Cookies funcionales",
      desc: "Usadas para recordar preferencias como idioma o tema.",
    },
  },
  placeholder: {
    title: "Contenido bloqueado",
    desc: "Necesitas permitir las cookies de {category} para ver este contenido.",
    cta: "Permitir",
  },
  tabs: {
    categories: "Categories",
    services: "Services",
    about: "About",
  },
  service: {
    description: "Description",
    processor: "Data Processor",
    address: "Address",
    dpo: "DPO Contact",
    purposes: "Purposes",
    technologies: "Technologies Used",
    dataCollected: "Data Collected",
    legalBasis: "Legal Basis",
    retention: "Retention Period",
    transferCountries: "Transfer Countries",
    privacyPolicy: "Privacy Policy",
    cookiePolicy: "Cookie Policy",
    legalBasisValues: {
      consent: "Consent (Art. 6 para. 1 s. 1 lit. a GDPR)",
      legitimate_interest: "Legitimate Interest (Art. 6 para. 1 s. 1 lit. f GDPR)",
    },
    noServices: "No services are configured for this site.",
  },
  svcAbout: {
    title: "About this CMP",
    description:
      "This website uses Blakfy Cookie Management Platform (CMP) to manage your consent preferences in compliance with GDPR, KVKK, CCPA and other applicable privacy regulations.",
    version: "Version",
    learnMore: "Learn more at blakfy.com",
  },
};
